<template>
    <div class="results" @click="showExist = false">
      <i class="iconfont iconfanhui back" @click.stop="$router.push({path: '/ceramide'})">返回</i>
      <van-icon class="bars" name="bars" color="#3A75B4" size="0.175rem" @click.stop="showExist = !showExist"/>
      <SideBar :show="showExist"></SideBar>

      <div class="results_wrap">
        <div class="card">编号{{ scode }},{{ datatime }}</div>
        <div class="results_box">
          <p class="results_title">检测结果</p>
          <p class="tips">您本次血液神经酰胺CER检测结果及心血管疾病风险评估结果为：</p>
          <van-grid :column-num="3">
            <van-grid-item>代谢物名称</van-grid-item>
            <van-grid-item>检测结果</van-grid-item>
            <van-grid-item>参考值</van-grid-item>
          </van-grid>
          <van-grid :column-num="3" v-for="(item, index) in houseResult" :key="index">
            <van-grid-item>{{ item.name }}</van-grid-item>
            <van-grid-item :class="{ red: item.higher }">{{ item.value }}</van-grid-item>
            <van-grid-item>{{ item.reference }}</van-grid-item>
          </van-grid>
          <div class="risk">
            <p class="risk_title">{{ timeSpan }}年内发病风险约为：</p>
            <div class="risk_num">{{ risk | fixed(2)}}%</div>
          </div>
          <div class="risk risk_multiple">
            <p class="risk_title">与同龄人相比您的发病风险倍数：</p>
            <div class="risk_multiple_img">
              <img :style="{ left: riskMultiple / maxRiskMultiple * 100 + '%' }" src="../../assets/images/ceramide/heart.png" alt="心脏">
              <div class="risk_gradient">
                <i class="vertical_line" :style="{ left: riskMultiple / maxRiskMultiple * 100 + '%' }"></i>
              </div>
              <p class="min">{{ minRiskMultiple | fixed(1) }}</p>
              <p class="multiple" :style="{ left: riskMultiple / maxRiskMultiple * 100 + '%' }">{{ riskMultipleNum }}倍</p>
              <p class="max">{{ maxRiskMultiple | fixed(1) }}</p>
            </div>
            <div class="riskLevel">
              <p class="risk_title">您的发病风险等级：</p>
              <van-collapse v-model="activeNames">
                <van-collapse-item name="1">
                  <template #title>
                    <p class="rlevel" :class="{high: riskLevel === '高等风险', higher: riskLevel === '较高风险', general: riskLevel === '中等风险', low: riskLevel === '低等风险'}">
                      {{ riskLevel }}
                    </p>
                  </template>
                  <p>风险等级分为：低等风险，中等风险，较高风险，高等风险。</p>
                </van-collapse-item>
              </van-collapse>
            </div>
          </div>
        </div>
        <div class="health_advice">
          <p class="pk" @click="$router.push({path: '/healthDataPK'})">健康数据 PK<van-icon class="arrow" name="play" color="#2A6BAE"/></p>
          <div class="results_box">
            <p class="results_title">健康管理建议</p>
            <div class="advice_tab">
              <p :class="{ active: active === 0 }" @click="active = 0">健管建议</p>
              <p :class="{ active: active === 1 }" @click="active = 1">报告解读</p>
            </div>
            <div class="advice_item" v-show="active === 0">
              {{ healthAdvice }}
            </div>
            <div class="advice_item" v-show="active === 1">
              {{ reportInterpertation }}
            </div>
            <div class="advice_btn" @click="$router.push({path: '/riskFactors'})">
              <p>查看心血管危险因素</p>
            </div>
          </div>
        </div>
        <div class="history">
          <div class="results_box">
            <p class="results_title">历史记录</p>
            <div id="myChart" class="myChart"></div>
            <p class="word">人体中的代谢物是一项动态指标，代谢物的浓度水平随着饮食、生活方式等外界因素始终变化，血浆神经酰胺是可改变的危险指标，研究发现，通过限制摄入热量，有氧运动和他汀类药物疗法（用药需在医生指导下进行，标准的他汀类药物疗法，例如辛伐他汀、瑞舒伐他汀，可在五周内显著降低血浆神经酰胺），神经酰胺浓度显著降低。我们根据您进行心血管疾病风险的持续评估做了回顾性服务，记录您心血管风险指标的长期变化趋势，及时改进或调整对您的健康管理方案，为您提供最个性化和精准的服务。</p>
          </div>
        </div>
        <div class="health_advice">
          <p class="pk" @click="$router.push({path: '/cerMoreInfo'})">* 了解神经酰胺更多信息 <van-icon class="arrow" name="play" color="#2A6BAE"/></p>
          <div class="results_box">
            <p class="results_title">参考文献</p>
            <div class="word">
              <p>1. Meikle PJ, Wong G, Tsorotes D, et al: Plasma lipidomic analysis of stable and unstable coronary artery disease. Arterioscler Thromb Vasc Biol 2011 Nov;31(11):2723-32</p>
              <p>2. Bergman BC, Brozinick JT, Strauss A, et al: Serum sphingolipids: relationships to insulin sensitivity and changes with exercise in humans. Am J Physiol Endocrinol Metab. 2015 Aug;309(4):E398-408</p>
              <p>3. Pan W, Yu J, Shi R, et al: Elevation of ceramide and activation of secretory acid sphingomyelinase in patients with acute coronary syndromes. Coron Artery Dis. 2014 May;25(3):230-5</p>
              <p>4. Laaksonen R, Ekroos K, Sysi-Aho M, et al: Plasma ceramides predict cardiovascular death in patients with stable coronary artery disease and acute coronary syndromes beyond LDL-cholesterol. Eur Heart J. 2016 April;28: pii: ehw148. [Epub ahead of print]</p>
              <p>5. Yu J, Pan W, Shi R, et. al: Ceramide is upregulated and associated with mortality in patients with chronic heart failure. Can J Cardiol. 2015 Mar;31(3):357-63</p>
              <p>6. Tarasov K, Ekroos K, Suoniemi M, et al: Molecular Lipids Identify Cardiovascular RIsk and Are Efficiently Lowered by Simvastatin and PCSK9 Deficiency. J Clin Endocrinol Metab. 2014 Nov;99(11):E45-52</p>
              <p>7. Ng TW, Ooi EM, Watts GF, et al: Dose-dependent effects of rosuvastatin on the plasma sphingolipidome and phospholipidome in the metabolic syndrome. J Clin Endocrinol Metab. 2014 Nov;99(11):E2335-40</p>
              <p>8. Khot UN, Khot MB, Bajzer CT, et al: Prevalence of conventional risk factors in patients with coronary heart disease. JAMA 2003 Aug;290(7)898-904</p>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import SideBar from '@/components/SideBarResults.vue'
export default {
  name: 'results',
  data () {
    return {
      active: 0,
      activeNames: ['0'],
      showExist: false,
      houseResult: [],
      timeSpan: 1,
      risk: 1,
      riskMultiple: 1,
      riskMultipleNum: 1,
      history: [],
      healthAdvice: '',
      reportInterpertation: '',
      scode: this.util.getLS('sample_code'),
      minRiskMultiple: '',
      maxRiskMultiple: '',
      riskLevel: '',
      date: '',
      datatime: ''
    }
  },
  components: {
    SideBar
  },
  watch: {
    'scode': function () {
      // this.util.setLS('sample_code', this.scode)
      this.$router.push('/historyInfo/' + this.date + '/' + this.scode)
    }
  },
  methods: {
    drawChart () {
      let time = []
      let series = []
      this.history.forEach(item => {
        time.push(item.x)
      })
      this.history.forEach((item, index) => {
        series.push([index].concat([item.y], [item.scode]))
      })
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))

      // 绘制图表
      myChart.setOption({
        xAxis: {
          type: 'category',
          data: time
        },
        yAxis: {
          name: '%',
          type: 'value',
          nameGap: 5,
          triggerEvent: true
        },
        series: {
          type: 'line',
          data: series
        }
      })
      myChart.on('click', (param) => {
        let value = param.value
        this.date = param.name
        this.scode = value[2]
      })
      window.onresize = myChart.resize
    },
    result () {
      let data = {
        scode: this.scode
      }
      this.util.get(this.api.result, data, (success) => {
        this.timeSpan = success.data.timeSpan
        this.risk = success.data.risk
        this.riskMultipleNum = success.data.riskMultiple
        this.healthAdvice = success.data.healthAdvice
        this.reportInterpertation = success.data.reportInterpretation
        this.history = success.data.history
        this.houseResult = success.data.houseResult
        this.minRiskMultiple = success.data.minRiskMultiple
        this.maxRiskMultiple = success.data.maxRiskMultiple
        this.history.forEach(item => {
          if (this.scode === item.scode) {
            this.datatime = item.x
          }
        })
        let num = (this.maxRiskMultiple - this.minRiskMultiple) / 2
        if (this.riskMultipleNum > num) {
          this.riskMultiple = this.riskMultipleNum
        } else {
          this.riskMultiple = this.riskMultipleNum - 1
        }
        this.riskLevel = success.data.riskLevel
        for (let i in this.houseResult) {
          this.houseResult[i].name = i
          switch (i) {
            case 'cer-1':
              this.houseResult[i].reference = '0.19–0.36 mcmol/L'
              break
            case 'cer-2':
              this.houseResult[i].reference = '0.05–0.14 mcmol/L'
              break
            case 'cer-3':
              this.houseResult[i].reference = '0.65–1.65 mcmol/L'
              break
            case 'cer-1/cer-4':
              this.houseResult[i].reference = '<0.11'
              break
            case 'cer-2/cer-4':
              this.houseResult[i].reference = '<0.05'
              break
            case 'cer-3/cer-4':
              this.houseResult[i].reference = '<0.45'
              break
          }
        }
        this.drawChart()
      })
    }
  },
  mounted () {
    this.result()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .results {
    width: 100%;
    height: 100%;
    background: #C4E3FE;
    position: relative;
    overflow: auto;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .bars {
      position: absolute;
      top: pxToRem(20px);
      right: pxToRem(30px);
    }

    .high {
      color: #e3542b;
    }

    .higher {
      color: #f3ac3c;
    }

    .general {
      color: #80ba41;
    }

    .low {
      color: #71c2de;
    }

    .results_wrap {
      position: relative;
      clear: both;
      width: 100%;
      padding: 0 pxToRem(36px);
      margin: pxToRem(92px) auto;

      .card {
        position: absolute;
        top: pxToRem(-26px);
        left: 50%;
        transform: translateX(-50%);
        background: url('../../assets/images/ceramide/card.png') no-repeat center;
        background-size: 100% 100%;
        font-size: pxToRem(12px);
        color: #fff;
        text-align: center;
        width: pxToRem(400px);
        height: pxToRem(70px);
        line-height: pxToRem(70px);
      }

      .results_box {
        padding: pxToRem(80px);
        background: #fff;
        border-radius: pxToRem(20px);

        .results_title {
          font-size: pxToRem(36px);
          font-weight: bold;
          color: #2A6BAE;
          text-align: center;
          margin-bottom: pxToRem(53px);
        }

        .tips {
          margin-bottom: pxToRem(40px);
        }

        .risk {
          margin-top: pxToRem(68px);

          .risk_title {
            font-size: pxToRem(22px);
            font-weight: bold;
            color: #000;
          }

          .risk_num {
            width: pxToRem(90px);
            height: pxToRem(90px);
            line-height: pxToRem(90px);
            font-size: pxToRem(18px);
            text-align: center;
            color: #fff;
            background: url('../../assets/images/ceramide/riskBg.png') no-repeat center;
            background-size: cover;
            border-radius: 50%;
            margin: pxToRem(10px) auto 0;
          }
        }

        .risk_multiple {
          margin-top: pxToRem(30px);

          .risk_multiple_img {
            position: relative;
            margin-top: pxToRem(20px);
            padding-bottom: pxToRem(180px);

            img {
              position: absolute;
              top: 0;
              left: 0;
              width: pxToRem(70px);
              height: pxToRem(40px);
              margin-left: pxToRem(-35px);
            }

            .risk_gradient {
              width: 100%;
              height: pxToRem(38px);
              border-radius: pxToRem(10px);
              background: url('../../assets/images/ceramide/gradient.png') no-repeat center;
              background-size: cover;
              position: absolute;
              top: pxToRem(50px);
              left: 0;

              .vertical_line {
                width: pxToRem(37px);
                height: pxToRem(38px);
                border-right: 1px solid #fff;
                position: absolute;
                margin-left: pxToRem(-38px);
                left: 0;
              }
            }

            .min, .max {
              position: absolute;
              font-size: pxToRem(19px);
              bottom: 0;
            }

            .max {
              right: 0;
            }

            .multiple {
              font-size: pxToRem(19px);
              text-align: center;
              width: pxToRem(70px);
              margin-left: pxToRem(-35px);
              position: absolute;
              top: pxToRem(100px);
            }
          }

          .riskLevel {
            margin-top: pxToRem(30px);

            .rlevel {
              font-size: pxToRem(32px);
              font-weight: bold;
              text-align: center;
              margin-top: pxToRem(10px);
            }
          }
        }
      }

      .health_advice {
        margin-top: pxToRem(50px);

        .pk {
          font-size: pxToRem(22px);
          font-weight: 300;
          text-align: right;
          margin-bottom: pxToRem(28px);

          .arrow {
            margin-left: pxToRem(10px);
            vertical-align: middle;
          }
        }

        .advice_tab {
          display: flex;
          justify-content: space-around;
          align-items: center;
          p {
            width: pxToRem(254px);
            height: pxToRem(64px);
            line-height: pxToRem(64px);
            text-align: center;
            font-size: pxToRem(20px);
            font-weight: 300;
            color: #7aa7d1;
            letter-spacing: 1px;
            background: #2a68b1;
          }
          .active {
            background: #469fe3;
            color: #fff;
          }
        }

        .advice_item {
          font-size: pxToRem(22px);
          text-indent: 2em;
          padding: pxToRem(80px) pxToRem(27px);
          text-align: justify;
        }

        .advice_btn {
          text-align: center;
          margin-top: pxToRem(40px);

          p {
            display: inline-block;
            background: url('../../assets/images/ceramide/healthbtn.png') no-repeat center;
            background-size: 100% 100%;
            font-size: pxToRem(28px);
            color: #fff;
            text-align: center;
            padding: pxToRem(12px) pxToRem(50px)  pxToRem(16px);
          }
        }
      }

      .history {
        margin-top: pxToRem(50px);

        .results_title {
          margin: 0;
        }

        .myChart {
          width: 100%;
          height: pxToRem(400px);
        }
      }
    }
    .word {
      font-size: pxToRem(22px);
      font-weight: 300;
      color: #221815;
      text-indent: 1em;
      text-align: justify;
    }
  }
</style>
<style lang="scss">
  .results {
    .van-grid {
      flex-wrap: nowrap;
    }
    .van-grid:nth-of-type(even) .van-grid-item__content {
      background: #fff;
    }
    .van-grid:nth-of-type(odd) .van-grid-item__content {
      background: #E3F2FF;
    }
    .van-grid:nth-of-type(1) .van-grid-item__content {
      background: #C4E3FE;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ceramide/results.vue